import React from "react";
import { useTranslation } from "react-i18next";

import { InfoBlock, Text } from "@fragments";
import Parser from "@helpers/parser.js";
import MetricCard from "@pages/Banking/components/MetricCard";
import { walletBalanceCurrency, walletIsConnected } from "@helpers/wallets";

// The Global Wallet has no in-app withdrawal request: Stripe pays the
// connected bank account out automatically, in the account's settlement
// currency. The summary mirrors the numbers the Stripe Express dashboard
// shows for those payouts.
export default function StripePayoutSummary({ wallet, loading }) {
    const { t } = useTranslation("banking");

    if (!loading && !walletIsConnected(wallet)) return null;

    const currency = walletBalanceCurrency(wallet, "USD");
    const available = parseInt(wallet?.balance?.available, 10) || 0;
    const pending = parseInt(wallet?.balance?.pending, 10) || 0;
    const last4 = wallet?.onboarding?.externalAccountLast4;

    return (
        <div className="stripe-payout-summary mt-3">
            <Text.h3 weight={500} className="mb-2">
                {t("withdrawals.stripeSummary.title")}
            </Text.h3>

            <InfoBlock
                title={t("withdrawals.stripeSummary.infoTitle")}
                description={t("withdrawals.stripeSummary.infoDescription")}
                className="mb-2"
            />

            <div className="metrics-row">
                <MetricCard
                    title={t("withdrawals.stripeSummary.available")}
                    metric={Parser.price.format(available, currency)}
                    submetric={currency}
                    loading={loading}
                />
                <MetricCard
                    title={t("withdrawals.stripeSummary.pending")}
                    metric={Parser.price.format(pending, currency)}
                    submetric={t("withdrawals.stripeSummary.pendingSubmetric")}
                    loading={loading}
                />
                <MetricCard
                    title={t("withdrawals.stripeSummary.destination")}
                    metric={last4 ? `•••• ${last4}` : "Stripe Express"}
                    submetric={t("withdrawals.stripeSummary.destinationSubmetric")}
                    loading={loading}
                />
            </div>
        </div>
    );
}
